import React, {useEffect, useRef, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {sendEmailResetPass} from '../apis'
import {Alerts} from '../../../components'
import * as component from '../../../components/redux/componentRedux'
import {useDispatch} from 'react-redux'
import {messageError} from '../../../utils'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      dispatch(component.actions.showBackdrop({show: true}))
      setTimeout(() => {
        let model = {
          model: {
            email: values.email,
            applicationType: 2,
          },
        }
        sendEmailResetPass(model)
          .then((res: any) => {
            if (res && !res.isError) {
              setLoading(false)
              dispatch(component.actions.showBackdrop({show: false}))
              setSubmitting(false)
              dispatch(
                component.actions.writeAlert({
                  show: true,
                  type: 'success',
                  message:
                    'Chúng tôi đã nhận được yêu cầu đặt lại mật khẩu. Nếu tài khoản đã được đăng ký, một liên kết để đặt lại mật khẩu sẽ được gửi đến email của người dùng!',
                })
              )
            }
          })
          .catch((error) => {
            dispatch(component.actions.showBackdrop({show: false}))
            dispatch(
              component.actions.writeAlert({
                show: true,
                type: 'error',
                message: messageError(error.response),
              })
            )
            setSubmitting(false)
          })
      }, 1000)
    },
  })
  return (
    <>
      <Alerts />
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Quên mật khẩu?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Nhập email của bạn để đặt lại mật khẩu.</div>
          {/* end::Link */}
        </div>

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>
              Chúng tôi đã nhận được yêu cầu đặt lại mật khẩu. Nếu tài khoản đã được đăng ký, một
              liên kết để đặt lại mật khẩu sẽ được gửi đến email của người dùng.
            </div>
          </div>
        )}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'></span>
              </div>
            </div>
          )}
        </div>
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
          >
            <span className='indicator-label'>Gửi</span>
            {loading && (
              <span className='indicator-progress'>
                Vui lòng đợi...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Huỷ
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
